// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: var(--background-color);
  color: var(--text-color);
}

.privacy-policy-content {
  margin-top: 2rem;
}

.privacy-policy-container h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.privacy-policy-container h2 {
  font-size: 1.5rem;
  margin: 1.5rem 0 1rem;
  color: var(--secondary-color);
}

.privacy-policy-container h3 {
  font-size: 1.2rem;
  margin: 1rem 0;
  color: var(--text-color);
}

.privacy-policy-container section {
  margin-bottom: 2rem;
}

.privacy-policy-container ul {
  margin: 1rem 0;
  padding-left: 2rem;
  list-style-type: disc;
}

.privacy-policy-container li {
  margin: 0.5rem 0;
}

.last-updated {
  color: var(--text-muted);
  font-style: italic;
  margin-bottom: 2rem;
}

.privacy-policy-container p {
  margin: 1rem 0;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/legal/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".privacy-policy-container {\n  max-width: 800px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.privacy-policy-content {\n  margin-top: 2rem;\n}\n\n.privacy-policy-container h1 {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.privacy-policy-container h2 {\n  font-size: 1.5rem;\n  margin: 1.5rem 0 1rem;\n  color: var(--secondary-color);\n}\n\n.privacy-policy-container h3 {\n  font-size: 1.2rem;\n  margin: 1rem 0;\n  color: var(--text-color);\n}\n\n.privacy-policy-container section {\n  margin-bottom: 2rem;\n}\n\n.privacy-policy-container ul {\n  margin: 1rem 0;\n  padding-left: 2rem;\n  list-style-type: disc;\n}\n\n.privacy-policy-container li {\n  margin: 0.5rem 0;\n}\n\n.last-updated {\n  color: var(--text-muted);\n  font-style: italic;\n  margin-bottom: 2rem;\n}\n\n.privacy-policy-container p {\n  margin: 1rem 0;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
